<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!-- <bita-ibox :is-loading="isLoading"> -->
        <!-- <div slot="header">
            <div class="ibox-title">
              <h4>اطلاعات یک هفته اخیر</h4>
            </div>
          </div> -->
        <!-- <div slot="body"> -->
        <div class="k-rtl">
          <div class="row">
            <div class="col-lg-3">
              <div class="widget style1 red-bg">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-user-plus fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>کاربران جدید</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.users_count }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="widget style1 navy-bg">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-cart-plus fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>محصول جدید</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.products_count }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="widget style1 lazur-bg">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-shopping-basket fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>تعداد سفارش </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="widget style1 yellow-bg">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-comments fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span> نظر ثبت شده </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.comments_count }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-3">
              <div class="widget style1 navy-bg">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-cart-plus fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>موجودی پیامک</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.products_count }}
                    </h2>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- </bita-ibox> -->
      <!-- </div> -->
    </div>
    <div class="row" v-if="$showDashboardWarnings">
      <div class="col-lg-6">
        <bita-ibox :is-loading="isLoading">
          <div slot="body">
            <table class="table stat-chip-table">
              <tbody>
                <tr>
                  <td>
                    <button type="button" class="btn btn-danger stat-chip m-r-sm">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.jobs_count }}
                    </button>
                    فعالیت های در صف
                  </td>
                  <td>
                    <button type="button" class="btn btn-danger stat-chip m-r-sm">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count_new }}
                    </button>
                    بررسی نشده
                  </td>
                </tr>
                <tr>
                  <td>
                    <button type="button" class="btn btn-warning stat-chip m-r-sm">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.failed_jobs_count }}
                    </button>
                    فعالیت های ناموفق
                  </td>
                  <td>
                    <button type="button" class="btn btn-warning stat-chip m-r-sm">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count_cargochecking }}
                    </button>
                    بررسی انبار
                  </td>
                </tr>
                <tr>
                  <td>
                    <button type="button" class="btn btn-info stat-chip m-r-sm">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ sysStatus.sms_credit ? JSON.parse(sysStatus.sms_credit.value).credit : "" }}
                    </button>
                    موجودی پیامک
                  </td>
                  <td>
                    <button type="button" class="btn btn-success stat-chip m-r-sm">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.orders_count_sent }}
                    </button>
                    ارسال شده
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </bita-ibox>
      </div>
      <div class="col-lg-6 d-flex flex-wrap">
        <div
          class="col-sm-4 col-6 px-1"
          v-if="
            sysStatus.last_job_runtime && sysStatus.last_job_runtime.alarm_status
          "
        >
          <div class="widget yellow-bg p-lg text-center">
            <div class="m-b-md">
              <i class="fas fa-exclamation-triangle"></i>
              <h4 class="m-xs">هشدار</h4>
              <h5 class="font-bold no-margins">ایجاد اشکال</h5>
              <small>در سیستم وظایف</small>
            </div>
          </div>
        </div>
        <div
          class="col-sm-4 col-6 px-1"
          v-if="
            sysStatus.last_sms_delivery_check &&
            sysStatus.last_sms_delivery_check.alarm_status
          "
        >
          <div class="widget yellow-bg p-lg text-center">
            <div class="m-b-md">
              <i class="fas fa-exclamation-triangle"></i>
              <h4 class="m-xs">هشدار</h4>
              <h5 class="font-bold no-margins">ایجاد اشکال</h5>
              <small>در سیستم چک دلیوری</small>
            </div>
          </div>
        </div>
        <div
          class="col-sm-4 col-6 px-1"
          v-if="sysStatus.sms_credit && sysStatus.sms_credit.alarm_status"
        >
          <div class="widget yellow-bg p-lg text-center">
            <div class="m-b-md">
              <i class="fas fa-exclamation-triangle"></i>
              <h4 class="m-xs">هشدار</h4>
              <h5 class="font-bold no-margins">کمبود شارژ</h5>
              <small>پیامک ({{ sysStatus.sms_credit.value }})</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2 mb-5">
      <div class="col-lg-6">
        <bita-ibox :is-loading="isLoading">
          <!-- <div slot="header">
            <div class="ibox-title">
              <h4>آمار درامد روزانه هفته اخیر</h4>
            </div>
          </div> -->
          <div slot="body">
            <div class="k-rtl">
              <h4>آمار درامد روزانه هفته اخیر</h4>
              <table class="table table-hover margin bottom">
                <thead>
                  <tr>
                    <th style="width: 1%" class="text-center">ردیف</th>
                    <th class="text-center">روز</th>
                    <th class="text-center">تعداد سفارش</th>
                    <th class="text-center">{{ $currencyLabel("درامد") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) of total.week_income" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">{{ $getJalaliDate(item.day) }}</td>
                    <td class="text-center">{{ item.count }}</td>
                    <td class="text-center">
                      <span
                        :class="{
                          label: true,
                          'label-primary':
                            Number(item.total_income) >
                            Number(total.avg_income),
                          'label-warning':
                            Number(item.total_income) <=
                            Number(total.avg_income),
                        }"
                        >{{
                          $thousandSeprator($round(item.total_income))
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </bita-ibox>
      </div>
      <div class="col-lg-6">
        <bita-ibox :is-loading="isLoading">
          <!-- <div slot="header">
            <div class="ibox-title">
              <h4>سفارش های جدید</h4>
            </div>
          </div> -->
          <div slot="body">
            <div class="k-rtl">
              <h4>8 سفارش جدید ثبت شده</h4>
              <table
                v-if="total && total.orders && total.orders.length > 0"
                class="table table-hover margin bottom"
              >
                <thead>
                  <tr>
                    <th style="width: 1%" class="text-center">ردیف</th>
                    <th>نام</th>
                    <th class="text-center">زمان ثبت سفارش</th>
                    <th class="text-center">{{ $currencyLabel("مبلغ") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) of total.orders" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ item.full_name }}</td>
                    <td class="text-center small">
                      {{ $getJalaliDateTime(item.created_at) }}
                    </td>
                    <td class="text-center">
                      <span class="label label-primary">{{
                        $thousandSeprator(item.payable)
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-center" v-else>سفارش جدیدی ثبت نشده است</div>
            </div>
          </div>
        </bita-ibox>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import { dashboardApi } from "@/api/apiManagement.js";
export default {
  name: "Home",
  data() {
    return {
      dashboard: {},
      total: {},
      sysStatus: {},
      isLoading: false,
    };
  },
  mounted() {
    this.getDashboardData();
    if (this.$store.state.layout != "app-layout") this.$setLayout("app-layout");
  },
  methods: {
    getDashboardData() {
      this.isLoading = true;
      dashboardApi.getInfo().then(({ data }) => {
        this.dashboard = data;
        this.total = data.total;
        this.sysStatus = data.system_statuses;
        this.isLoading = false;
      });
    },
  },
};
</script>
